/**
 * Bobbi Brown Globe Game
 */
/* eslint complexity: 0 */
var site = site || {};
var randomPrize = window.randomPrize || {};

window.dataLayer = window.dataLayer || [];

(function ($) {
  Drupal.behaviors.snowGlobeV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var _nodes = {
        main: $('#bb_snow_globe', context),
        buttonPlay: $('#play-button', context),
        landingElement: $('.snow-globe .game-landing .element', context),
        gamePopupBox: $('.game-popup-box', context),
        gamePopupBoxInner: $('.game-popup-box-inner-wrapper', context),
        gamePopupBoxClose: $('.game-popup-box-inner-wrapper .game-popup-box-close', context),
        buttonApplyOffer: $('.game-popup-box .button-apply', context),
        winOfferMessage: $('.game-win-description', context),
        winOfferImage: $('.game-win-image', context)
      };
      var _settings = {
        canvasWidth: parseInt($('#canvas_width', context).val()) || 566,
        canvasHeight: parseInt($('#canvas_height', context).val()) || 566,
        numberOfSnowflakesDesktop: parseInt($('#no_of_snowflakes_desktop', context).val()) || 4000,
        numberOfSnowflakesMobile: parseInt($('#no_of_snowflakes_mobile', context).val()) || 1000,
        redirectAfterApplyOffer: $('#game_after_apply_redirect', context).val() || '/',
        showPopupDelayTime: parseInt($('#popup_show_delay_time', context).val()) || 1
      };
      var analytics = function analytics($track) {
        if (!window.site) {
          return;
        }

        if ('track' in window.site && 'evtLink' in window.site.track) {
          window.site.track.evtLink($track);

          return true;
        } else {
          return;
        }
      };
      var redirectAfterApplyOffer = function redirectAfterApplyOffer() {
        window.location.href = _settings.redirectAfterApplyOffer;
      };
      var showWinBox = function showWinBox($fields) {
        _nodes.landingElement.fadeOut('fast', function () {
          _nodes.gamePopupBox.addClass('show');
          _nodes.gamePopupBoxInner.addClass('show');
        });
        _nodes.winOfferMessage.html($fields.description);
        _nodes.winOfferImage.css('background-image', 'url("' + $fields.image + '")');

        analytics({
          event_name: 'siteGame_win',
          event_category: 'Site Game',
          event_action: 'Win',
          product_impression_list: ['/siteGame'],
          product_impression_position: '1'
        });
      };
      var playGame = function playGame() {
        if ($(this).hasClass('disabled')) {
          return;
        }
        snowModule.shake();

        setTimeout(function () {
          showWinBox(randomPrize.getWinningOffer());
          snowModule.clearCanvas();
        }, _settings.showPopupDelayTime * 1000);

        _nodes.gamePopupBoxClose.on('click', function (e) {
          e.preventDefault();
          $(this).closest(_nodes.gamePopupBoxInner).removeClass('show');
          $(this).closest(_nodes.gamePopupBox).removeClass('show');
          _nodes.landingElement.fadeIn();
        });
      };
      var init = function init() {
        if (!window.randomPrize) {
          return;
        }
        randomPrize.init(function () {
          snowModule.startSnow();
          _nodes.buttonPlay.on('click', playGame);

          _nodes.buttonApplyOffer.on('click', function (e) {
            e.preventDefault();
            randomPrize.applyOffer(redirectAfterApplyOffer);
          });

          $('.game-loading').fadeOut(500);
        });
      };

      init();
    }
  };
})(jQuery);

(function () {
  var lastTime = 0;
  var vendors = ['webkit', 'moz'];

  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () {
        callback(currTime + timeToCall);
      }, timeToCall);

      lastTime = currTime + timeToCall;

      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
}());

var snowModule = (function ($) {
  var canvas = $('#canvas').get(0);
  // Make some snow!
  var snowFlakes = function snowFlakes(canvas) {
    this.canvas = canvas;
    this.context = canvas.getContext('2d');
    this.flakes = [];
    this.snow_pile = [];
    this.snow_curve = [];
    this.hue_choise = [];
    this.middle = Math.floor(canvas.width / 2);
    // Set an external flag to allow animations to continue
    this.continueAnimating = true;

    // Calculate Y offsets to make the snow pile curve
    for (var s = 0; s < this.canvas.width; s += 1) {
      this.snow_curve.push(Math.floor((s - this.middle)**2 * 0.00050) + 80);
    }
  };

  // Adds a snow flake object
  snowFlakes.prototype.addFlake = function (width, height, x_pos, y_pos, move_y, move_x, move_x_speed, stop_chance, rotate_amount, front_flake, color) {
    var newFlake = {
      width: width, // Pixel value of width
      height: height, // Pixel value of height
      x_pos: x_pos, // X position to draw flake on canvas
      y_pos: y_pos, // Y position to drawn flake on cavnas
      move_y: move_y, // Downward movement speed in pixels per tick
      move_x: move_x, // Wander amount in the X direction
      move_x_speed: move_x_speed, // Left and right movement speed in pixels per tick
      move_x_max: x_pos + move_x, // Max movement distance to the right in pixels
      move_x_min: x_pos - move_x, // Max movement distance to the left in pixels
      move_x_dir: !Math.floor((Math.random() * 2) + 0), // X movement direction - true == right, false == left
      stop_chance: stop_chance, // 1 out of stop_chance for flake to pile at the bottom
      stopped_falling: false, // Flag when flake has stopped falling and piled at the bottom
      returning: false, // Flag when flake is moving upward when globe is shook
      move_y_return_height: Math.floor((Math.random() * this.canvas.height) + 0), // Y position for flake to travel to when globe is shook
      move_y_return: -Math.floor((Math.random() * 2) + 2), // Y speed in pixels per tick flake travels when globe is shook
      move_x_speed_return: Math.floor((Math.random() * 2) + 2), // X speed in pixesl per tick flake travels when globe is shook
      rotate_amount: rotate_amount, // Roation amount of flake
      rotate_change: rotate_amount, // Rotation change amount per tick
      front_flake: front_flake, // Flag if flake should render in front of images
      color: color // Color of flake
    };

    this.flakes.push(newFlake);
  };

  snowFlakes.prototype.getRandomInt = function (min, max) {
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  snowFlakes.prototype.random_color = function () {
    var that = this;
    var red = that.getRandomInt(255, 255);
    var green = that.getRandomInt(241, 255);
    var blue = that.getRandomInt(70, 255);

    return 'rgb(' + red + ',' + green + ',' + blue + ')';
  };

  // Render all snow flakes
  snowFlakes.prototype.render = function () {
    var num_flakes = this.flakes.length;
    var a;

    // Clear the canvas
    this.canvas.width = this.canvas.width;

    // Draw back layer snow flakes
    for (a = 0; a < num_flakes; a += 1) {
      if (this.flakes[a].front_flake === false) {
        this.context.fillStyle = this.flakes[a].color;
        this.context.fillRect(this.flakes[a].x_pos, this.flakes[a].y_pos, this.flakes[a].width, this.flakes[a].height);
      }
    }

    // Draw front layer snow flakes
    for (a = 0; a < num_flakes; a += 1) {
      if (this.flakes[a].front_flake === true) {
        this.context.fillStyle = this.flakes[a].color;
        this.context.fillRect(this.flakes[a].x_pos, this.flakes[a].y_pos, this.flakes[a].width, this.flakes[a].height);
      }
    }
  };

  // Updates the position of the snow flakes
  snowFlakes.prototype.updateFlakePosition = function () {
    var num_flakes = this.flakes.length;
    var max_fall;
    var new_y = 0;
    var new_x = 0;
    var lowest_pile;
    var pile_height;
    var stop_roll;

    // Update positions of all snow flakes
    for (var a = 0; a < num_flakes; a += 1) {
      // Check if snow flake is still moving
      if (this.flakes[a].stopped_falling === false) {
        // Move flake down
        new_y = this.flakes[a].y_pos + this.flakes[a].move_y;
        max_fall = this.canvas.height - this.snow_curve[Math.floor(this.flakes[a].x_pos)];
        if (new_y > max_fall) {
          // Roll if snow falls again or piles at bottom
          stop_roll = Math.floor((Math.random() * this.flakes[a].stop_chance) + 1);
          // Snow flake stops at bottom
          if (stop_roll === 1) {
            this.flakes[a].stopped_falling = true;
            var c;

            // Find lowest pile flake lands on
            lowest_pile = this.snow_pile[Math.floor(this.flakes[a].x_pos) + c] || 0;
            for (c = 0; c < this.flakes[a].width; c += 1) {
              pile_height = this.snow_pile[Math.floor(this.flakes[a].x_pos) + c] || 0;
              if (lowest_pile > pile_height) {
                lowest_pile = pile_height;
              }
            }
            // Set new y position for snow flake
            this.flakes[a].y_pos = max_fall - this.flakes[a].height - lowest_pile;
            // Force x position to be whole number
            this.flakes[a].x_pos = Math.floor(this.flakes[a].x_pos);
            // Set pile heights
            pile_height = lowest_pile + this.flakes[a].height;
            for (var d = 0; d < this.flakes[a].width; d += 1) {
              if ((this.snow_pile[Math.floor(this.flakes[a].x_pos) + d] || 0) < pile_height) {
                this.snow_pile[Math.floor(this.flakes[a].x_pos) + d] = pile_height;
              }
            }
          } else {
            // Snow flake falls again from top
            this.flakes[a].y_pos = -1 * this.flakes[a].height;
          }
        } else {
          // Update snow flake Y position
          this.flakes[a].y_pos = new_y;
        }
        // Move flakes left and right
        if (this.flakes[a].move_x_dir) {
          // Move right
          new_x = this.flakes[a].x_pos + this.flakes[a].move_x_speed;
          if (new_x > this.flakes[a].move_x_max) {
            this.flakes[a].x_pos -= this.flakes[a].move_x_speed;
            this.flakes[a].move_x_dir = false;
          } else if (new_x > this.canvas.width) {
            this.flakes[a].x_pos = -this.flakes[a].width;
          } else {
            this.flakes[a].x_pos = new_x;
          }
        } else {
          // Move left
          new_x = this.flakes[a].x_pos - this.flakes[a].move_x_speed;
          if (new_x < this.flakes[a].move_x_min) {
            this.flakes[a].x_pos += this.flakes[a].move_x_speed;
            this.flakes[a].move_x_dir = true;
          } else if (new_x < 0) {
            this.flakes[a].x_pos = this.canvas.width + this.flakes[a].width;
          } else {
            this.flakes[a].x_pos = new_x;
          }
        }
      }
      // Check for upward moving snow flakes going out of bounds
      if (this.flakes[a].returning === true && this.flakes[a].y_pos < this.flakes[a].move_y_return_height) {
        this.flakes[a].returning = false;
        this.flakes[a].move_y /= this.flakes[a].move_y_return;
        this.flakes[a].move_x_speed /= this.flakes[a].move_x_speed_return;
      }
    }
  };
  // Shakes the globe
  // Moves snow flakes up and images
  // along their predetermined path
  snowFlakes.prototype.shake = function () {
    var num_flakes = this.flakes.length;

    // Move the flakes up
    for (var a = 0; a < num_flakes; a += 1) {
      if (this.flakes[a].returning === false) {
        this.flakes[a].move_y *= this.flakes[a].move_y_return;
        this.flakes[a].move_x_speed *= this.flakes[a].move_x_speed_return;
        this.flakes[a].returning = true;
        this.flakes[a].stopped_falling = false;
        if (this.flakes[a].move_y_return_height < 0) {
          this.flakes[a].move_y_return_height += this.canvas.height / 2;
        }
        if (this.flakes[a].y_pos < this.flakes[a].move_y_return_height) {
          this.flakes[a].move_y_return_height -= this.canvas.height / 2;
        }
      }
    }

    // Reset the snow pile
    this.snow_pile = [];
  };

  // Clear canvas and stop animation
  snowFlakes.prototype.clearCanvas = function () {
    this.continueAnimating = false;
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
  };

  // Start the snow
  snowFlakes.prototype.startSnow = function () {
    var that = this;

    function animate() {
      if (that.continueAnimating) {
        requestAnimationFrame(animate);
        that.updateFlakePosition();
        that.render();
      }
    }
    animate();
  };

  var snowShow = new snowFlakes(canvas);
  var total_flakes = parseInt($('#no_of_snowflakes_desktop').val()) || 4000;
  var flake_starting_amount = Math.round((total_flakes / 100) * 30);
  var flake_width = 5;
  var flake_height = 5;

  // Reduce the number of snow flakes and
  // increase snow flake size on small screens
  if ($(window).width() < 1025) {
    total_flakes = parseInt($('#no_of_snowflakes_mobile').val()) || 1000;
  }

  // To control X Y position to draw flake on canvas
  var canvasXYPosition = 1;
  var canvasYEndPosition = 450;
  // To control Downward movement speed in pixels per tick
  var downwardYspeed = 50;
  // Wander amount in the X direction
  var wanderXposition = 50;
  // Left and right movement speed in pixels per tick
  var canvasLRspeed = 10;
  // To control flakes Rotation
  var flakesRotation = 5;

  // Create the snow flakes
  for (var b = 0; b < total_flakes; b += 1) {
    var x_spread = Math.floor((Math.random() * 800) + canvasXYPosition);
    var y_spread = b < flake_starting_amount ? Math.floor((Math.random() * 800) + canvasXYPosition) : Math.floor((Math.random() * 400) + canvasYEndPosition);
    var width = Math.floor((Math.random() * flake_width) + 1);
    var height = Math.floor((Math.random() * flake_height) + 1);
    var move_y = b < flake_starting_amount ? Math.floor((Math.random() * 80) + downwardYspeed) / 100 : Math.floor((Math.random() * 500) + downwardYspeed) / 100;
    var move_x = Math.floor((Math.random() * 500) + wanderXposition);
    var move_x_speed = Math.floor((Math.random() * 70) + canvasLRspeed) / 100;
    var stop_chance = 0.1; // 1 out of X chance to stop
    var rotate_amount = Math.floor((Math.random() * 5) + flakesRotation) * Math.PI / 180;
    var front_flake = Math.floor((Math.random() * 2) + 1) === 1 ? true : false;
    // var opacity = Math.floor((Math.random() * 10) + 1) / 10;
    var opacity = 1;
    var flake_color = 'rgba(254,252,243,' + opacity + ')';
    var color_rnd = Math.floor(Math.random() * 100);

    // Leave the most extreme colours on the edges
    if (color_rnd > 10 && color_rnd < 30) {
      flake_color = 'rgba(227,206,174,' + opacity + ')';
    } else if (color_rnd >= 30 && color_rnd < 50) {
      flake_color = 'rgba(172,142,88,' + opacity + ')';
    } else if (color_rnd >= 50 && color_rnd < 70) {
      flake_color = 'rgba(153,110,46,' + opacity + ')';
    } else if (color_rnd >= 70 && color_rnd < 90) {
      flake_color = 'rgba(100,69,24,' + opacity + ')';
    } else if (color_rnd >= 90) {
      flake_color = 'rgba(61,46,27,' + opacity + ')';
    }

    snowShow.addFlake(width, height, x_spread, y_spread, move_y, move_x, move_x_speed, stop_chance, rotate_amount, front_flake, flake_color);
  }

  return snowShow;
})(jQuery);
